import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import BusinessIcon from '@mui/icons-material/Business';
import { FaWhatsapp, FaTelegram } from 'react-icons/fa';

const Footer = (props) => {
  const email = process.env.REACT_APP_CONTACT_MAIL
  const phone = process.env.REACT_APP_CONTACT_PHONE
  const wa = process.env.REACT_APP_CONTACT_WHATSAPP
  const tgAlias = process.env.REACT_APP_CONTACT_TELEGRAM_ALIAS
  const tg = process.env.REACT_APP_CONTACT_TELEGRAM
  const address = process.env.REACT_APP_CONTACT_ADDRESS
  const news = process.env.REACT_APP_NEWS
  const articles = process.env.REACT_APP_ARTICLES

  const location = useLocation();

  const handleHomeClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.location.reload();
    }
  };

  return (
    <>
      <div className="footer-page">
        <div className="footer-wrap">
          <div className="footer-title">
            <span className="footer-lable">Company</span>
            
            <ul>
              <li>
                <NavLink 
                to="./"
                onClick={handleHomeClick}
                >
                  
                  Products</NavLink>
              </li>
              <li>
                <a className="underline" href={articles}>Articles</a>
              </li>                  
              <li>
                <a className="underline" href={news}>News</a>
              </li>  
              <li>
                  <NavLink to="./about">About Us</NavLink>
              </li>
            </ul>
          </div>

          <div className="footer-title">
            <span className="footer-lable">Contacts</span>


            <div className="footer-contacts__record">
            <div className="footer-contacts__record--left">
              <AlternateEmailIcon color="primary" mailto={`mailto:${email}`} />
            </div>  
              <a href={`mailto:${email}`}>{email}</a>
            </div>  

            <div className="footer-contacts__record">
            <div className="footer-contacts__record--left">
              <PhoneForwardedIcon color="primary" />
            </div>
            <a href={`tel:${phone}`}>{phone}</a>  
            </div>  



            <div className="footer-contacts__record">
              <div className="footer-contacts__record--left">
                <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp size={32} /> 
                </a>
              </div>  
                <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer">
                  <span>{wa}</span>
                </a>
            </div>  

            <div className="footer-contacts__record">
              <div className="footer-contacts__record--left">
                <a href={`https://t.me/${tgAlias}`} target="_blank" rel="noopener noreferrer">
                  <FaTelegram size={32} />
                </a>
              </div>  
                <a href={`https://t.me/${tg}`} target="_blank" rel="noopener noreferrer">
                  <span>@{tg}</span>
                </a>
            </div>  

            <div className="footer-contacts__record">
            <div className="footer-contacts__record--left">
              <BusinessIcon color="primary" />
            </div>  
            <span>{address}</span>
            </div>  


          </div>

          <div className="footer-rights"></div>
        </div>
      </div>
    </>
  );
};

export default Footer;
